<template>
  <div class="thank-you-block">
    <text-with-image-middle
        :title_tag="title_tag"
        :title="title"
        :content="content"
        :lazy_img_src="lazy_img_src"
        :img_src="img_src"
        :title_on_center="title_on_center"
        :title_with_content="title_on_top"
        :img_border_radius="img_border_radius"
        :fit_to_content="fit_img_to_content"
    />
  </div>
</template>

<script>

import TextWithImageInline from "../parts/builder/TextWithImageInline.vue";
import TextWithImageMiddle from "../parts/builder/TextWithImageMiddle.vue";

export default {
  name: "ThankYouBlock",
  components: {TextWithImageMiddle, TextWithImageInline},
  props: {
    /**props**/
    img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    img_border_radius: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    fit_img_to_content: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    title_tag: {
      type: String,
      default: 'h1',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    content: {
      type: String,
      default: '',
      required: true,
      admin_type: 'editor',
    },
    title_on_center: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    title_on_top: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    /**props**/
  },
}
</script>
